import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DefaultSpinner } from 'components';

import { ControlsActions } from 'actions/controls_actions';
import { Tables } from './table';
import { LeaderboardContainer } from './leaderboard';
import { LeaderboardTableContainer } from './leaderboard_table_original';
import GamificationControls from './gamification_controls';
import { useScopedLocationIds } from 'hooks/useAdminGroup/useScopedLocationIds';
import LocationScopeGate from 'hooks/useAdminGroup/LocationScopeGate';


const mapStateToProps = (state) => ({
  controlsState: state.controls.gamification || {},
});

const mapDispatchToProps = (dispatch) => ({
  controlsActions: bindActionCreators(ControlsActions, dispatch),
});

class GamificationContainer extends Component {
  static propTypes = {
    controlsState: PropTypes.object,
    controlsActions: PropTypes.object,
    scopeApplyScope: PropTypes.bool,
    scopeExternalIds: PropTypes.instanceOf(Set),
  };

  state = {};

  componentWillMount() {
    this.props.controlsActions.getMonitoringMetadata('gamification');
  }

  componentWillUnmount() {
    this.props.controlsActions.setInactive('gamification');
  }

  renderTables = (controlsState) => (
    <Tables
      key={'tables'}
      realTime={controlsState.realTime}
      callType={controlsState.callType}
      filterType={controlsState.filterType}
      filters={controlsState.filters || []}
      timeRange={controlsState.timeRange}
      nBuckets={controlsState.boardType.nBuckets}
      grouping={controlsState.grouping}
      scopeApplyScope={this.props.scopeApplyScope}
      scopeExternalIds={this.props.scopeExternalIds}
    />
  );

  renderLeaderboard = (controlsState) => (
    <LeaderboardContainer
      key={'leaderboard'}
      className="gamification"
      realTime={controlsState.realTime}
      callType={controlsState.callType}
      filterType={controlsState.filterType}
      filters={controlsState.filters || []}
      timeRange={controlsState.timeRange}
      nBuckets={controlsState.totalUsers}
      avatarStyle={controlsState.boardType.avatarStyle}
      sort={controlsState.boardType.sort}
      theme={controlsState.boardTheme.id}
      grouping={controlsState.grouping}
      perPage={controlsState.userCount.perPage}
      scopeApplyScope={this.props.scopeApplyScope}
      scopeExternalIds={this.props.scopeExternalIds}
    />
  );

  renderLeaderboardTable = (controlsState) => (
    <LeaderboardTableContainer
      key={'leaderboardTable'}
      realTime={controlsState.realTime}
      nBuckets={controlsState.boardType.nBuckets}
      callType={controlsState.callType}
      filterType={controlsState.filterType}
      filters={controlsState.filters || []}
      timeRange={controlsState.timeRange}
      grouping={controlsState.grouping}
      scopeApplyScope={this.props.scopeApplyScope}
      scopeExternalIds={this.props.scopeExternalIds}
    />
  );

  render() {
    const { controlsState } = this.props;
    let content;

    if (!controlsState.ready) {
      return <DefaultSpinner />;
    }

    if (controlsState.boardType.id.includes('retro')) {
      content = this.renderLeaderboardTable(controlsState);
    } else if (controlsState.boardType.id.includes('original')) {
      content = this.renderTables(controlsState);
    } else if (controlsState.boardType.id.includes('leaderboard')) {
      content = this.renderLeaderboard(controlsState);
    }

    return (
      <>
        {controlsState.metadata && (
          <GamificationControls />
        )}

        {content}
      </>
    );
  }
}

const ConnectedGamificationContainer = connect(mapStateToProps, mapDispatchToProps)(GamificationContainer);

// Admin-group/location breadcrumb scope isn't in Redux -- resolve it here and
// forward it as props down through whichever board type is rendered
// (Tables/LeaderboardContainer/LeaderboardTableContainer), down to where each
// leaf component's fetchData builds the request filters.
const GamificationContainerWithScope = (props) => {
  const scope = useScopedLocationIds();

  return (
    <LocationScopeGate scope={scope}>
      <ConnectedGamificationContainer
        {...props}
        scopeApplyScope={scope.applyScope}
        scopeExternalIds={scope.scopeExternalIds}
      />
    </LocationScopeGate>
  );
};

export default GamificationContainerWithScope;
